<template>
  <v-app>
    <v-main>
      <v-container
        fluid
        class="pa-0"
        :style="{
          height: '100vh'
        }"
      >
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>
<script>

export default {

}
</script>
